/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type AuthzPolicyEffect =
  | 'FORBID'
  | 'PERMIT';

export type DeleteAuthzPolicyInput = {
  guid: string | number;
};

export type AuthzPolicyFragment = { guid: string, name: string, effect: Types.AuthzPolicyEffect, principal:
    | { __typename: 'AnyAuthzPolicyPrincipal' }
    | { __typename: 'StaffAuthzPolicyPrincipal', staffGUID: string }
    | { __typename: 'TeamAuthzPolicyPrincipal', teamGUID: string }
  , action:
    | { __typename: 'AnyAuthzPolicyAction' }
    | { __typename: 'ReadRoomAuthzPolicyAction', isAssigned: boolean }
  , resource:
    | { __typename: 'AnyAuthzPolicyResource' }
    | { __typename: 'RoomAuthzPolicyResource', roomID: string }
   };

export type SettingsPageAuthzPolicyDetailViewQueryVariables = Exact<{
  guid: string | number;
}>;


export type SettingsPageAuthzPolicyDetailViewQuery = { authzPolicy: { guid: string, name: string, effect: Types.AuthzPolicyEffect, principal:
      | { __typename: 'AnyAuthzPolicyPrincipal' }
      | { __typename: 'StaffAuthzPolicyPrincipal', staffGUID: string }
      | { __typename: 'TeamAuthzPolicyPrincipal', teamGUID: string }
    , action:
      | { __typename: 'AnyAuthzPolicyAction' }
      | { __typename: 'ReadRoomAuthzPolicyAction', isAssigned: boolean }
    , resource:
      | { __typename: 'AnyAuthzPolicyResource' }
      | { __typename: 'RoomAuthzPolicyResource', roomID: string }
     } };

export type DeleteAuthzPolicyMutationVariables = Exact<{
  input: Types.DeleteAuthzPolicyInput;
}>;


export type DeleteAuthzPolicyMutation = { deleteAuthzPolicy: { __typename: 'DeleteAuthzPolicySuccessPayload' } };

export const AuthzPolicyFragmentDoc = gql`
    fragment AuthzPolicy on AuthzPolicy {
  guid
  name
  effect
  principal {
    __typename
    ... on AnyAuthzPolicyPrincipal {
      __typename
    }
    ... on StaffAuthzPolicyPrincipal {
      staffGUID
    }
    ... on TeamAuthzPolicyPrincipal {
      teamGUID
    }
  }
  action {
    __typename
    ... on AnyAuthzPolicyAction {
      __typename
    }
    ... on ReadRoomAuthzPolicyAction {
      isAssigned
    }
  }
  resource {
    __typename
    ... on AnyAuthzPolicyResource {
      __typename
    }
    ... on RoomAuthzPolicyResource {
      roomID
    }
  }
}
    `;
export const SettingsPageAuthzPolicyDetailViewDocument = gql`
    query SettingsPageAuthzPolicyDetailView($guid: ID!) {
  authzPolicy(guid: $guid) {
    ...AuthzPolicy
  }
}
    ${AuthzPolicyFragmentDoc}`;

/**
 * __useSettingsPageAuthzPolicyDetailViewQuery__
 *
 * To run a query within a Vue component, call `useSettingsPageAuthzPolicyDetailViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageAuthzPolicyDetailViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsPageAuthzPolicyDetailViewQuery({
 *   guid: // value for 'guid'
 * });
 */
export function useSettingsPageAuthzPolicyDetailViewQuery(variables: SettingsPageAuthzPolicyDetailViewQueryVariables | VueCompositionApi.Ref<SettingsPageAuthzPolicyDetailViewQueryVariables> | ReactiveFunction<SettingsPageAuthzPolicyDetailViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<SettingsPageAuthzPolicyDetailViewQuery, SettingsPageAuthzPolicyDetailViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageAuthzPolicyDetailViewQuery, SettingsPageAuthzPolicyDetailViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageAuthzPolicyDetailViewQuery, SettingsPageAuthzPolicyDetailViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsPageAuthzPolicyDetailViewQuery, SettingsPageAuthzPolicyDetailViewQueryVariables>(SettingsPageAuthzPolicyDetailViewDocument, variables, options);
}
export function useSettingsPageAuthzPolicyDetailViewLazyQuery(variables?: SettingsPageAuthzPolicyDetailViewQueryVariables | VueCompositionApi.Ref<SettingsPageAuthzPolicyDetailViewQueryVariables> | ReactiveFunction<SettingsPageAuthzPolicyDetailViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<SettingsPageAuthzPolicyDetailViewQuery, SettingsPageAuthzPolicyDetailViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageAuthzPolicyDetailViewQuery, SettingsPageAuthzPolicyDetailViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageAuthzPolicyDetailViewQuery, SettingsPageAuthzPolicyDetailViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsPageAuthzPolicyDetailViewQuery, SettingsPageAuthzPolicyDetailViewQueryVariables>(SettingsPageAuthzPolicyDetailViewDocument, variables, options);
}
export type SettingsPageAuthzPolicyDetailViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsPageAuthzPolicyDetailViewQuery, SettingsPageAuthzPolicyDetailViewQueryVariables>;
export const DeleteAuthzPolicyDocument = gql`
    mutation DeleteAuthzPolicy($input: DeleteAuthzPolicyInput!) {
  deleteAuthzPolicy(input: $input) {
    __typename
  }
}
    `;

/**
 * __useDeleteAuthzPolicyMutation__
 *
 * To run a mutation, you first call `useDeleteAuthzPolicyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAuthzPolicyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAuthzPolicyMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAuthzPolicyMutation(options: VueApolloComposable.UseMutationOptions<DeleteAuthzPolicyMutation, DeleteAuthzPolicyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteAuthzPolicyMutation, DeleteAuthzPolicyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteAuthzPolicyMutation, DeleteAuthzPolicyMutationVariables>(DeleteAuthzPolicyDocument, options);
}
export type DeleteAuthzPolicyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteAuthzPolicyMutation, DeleteAuthzPolicyMutationVariables>;